import { OverlayContainer } from '@angular/cdk/overlay';
import { Provider, DOCUMENT } from '@angular/core';

import {
  ESPShadowDomOverlayConfig,
  ESPShadowDomOverlayContainer,
} from '../components/shadow-dom-overlay.component';

export function provideESPShadowDomOverlay(
  config: ESPShadowDomOverlayConfig,
): Provider {
  return {
    provide: OverlayContainer,
    useClass: ESPShadowDomOverlayContainer,
    deps: [DOCUMENT],
    useFactory: (document: Document) =>
      new ESPShadowDomOverlayContainer(config, document),
  };
}
